(function () {
	if (typeof window === 'undefined') return;
	var el = document.getElementById('knightowl-blocks-data');
	if (!el) return;
	try {
		var data = JSON.parse(el.textContent);
		if (data.translations) window.knightowl_translations = data.translations;
		if (data.filter_data) window.knightowl_blocks_filter_data = data.filter_data;
		if (data.terms_filter_data) window.knightowl_blocks_terms_filter_data = data.terms_filter_data;
		if (data.load_data) window.knightowl_load_data = data.load_data;
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error('[knightowl-blocks] Failed to parse localized data:', e);
	}
})();
